import { Component, computed, inject } from '@angular/core';

import { faArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import { PreviewDevice } from '@empathy/survey/base';

import { MainTabs } from '../../models/main-tabs.enum';
import { EditorTranslationsService } from '../../services/editor-translations.service';
import { SurveyEditorService } from '../../services/survey-editor.service';

@Component({
  selector: 'empathy-preview-wrapper',
  templateUrl: 'preview-wrapper.component.html',
  styleUrls: ['./preview-wrapper.component.scss']
})
export class PreviewWrapperComponent {
  activeTranslationLanguage$ = inject(EditorTranslationsService).activeTranslationLanguage$;
  isTranslationsPreview$ = computed(() => this.surveyEditorService.mainTab$() === MainTabs.Translations);

  previewDevice = PreviewDevice;
  faArrowUpRight = faArrowUpRight;

  private surveyEditorService = inject(SurveyEditorService);
}
